import Order from '@/pages/Order'

export default {
  path: '/order',
  name: 'Order',
  component: Order
}



// WEBPACK FOOTER //
// ./src/router/order.js